// extracted by mini-css-extract-plugin
export default {"selectableChip":"LargeChip_selectableChip__1fFmH","large":"LargeChip_large__sYr6c"};